import { withStylePrefix } from '../common/withStylePrefix';
import { DataTableComponent, dataTableTemplate } from './DataTable';
import styles from './DataTable.styles.scss';
export const dataTableDefinition = {
    baseName: 'data-table',
    template: dataTableTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonDataTable = DataTableComponent.compose(dataTableDefinition);
